import React from "react";
import { Link } from "react-scroll";
// Assets
// import LogoImg from "../../assets/svg/Logo";

export default function Contact() {

  const getCurrentYear = () => {
    return new Date().getFullYear();
  }

  return (
    <div className="w-full bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-6 flex-col sm:flex-row">
          <Link className="flex items-center cursor-pointer" to="home" smooth={true} offset={-80}>
            <h1 className="text-sm font-extrabold ml-4">Xhosha Erdbewegungen GmbH</h1>
          </Link>
          <p className="text-xs sm:text-sm my-4 sm:my-0">
            © {getCurrentYear()} - <span className="font-extrabold">Xhosha Erdbewegungen GmbH</span> All Right Reserved
          </p>
          <Link className="text-xs sm:text-sm cursor-pointer" to="home" smooth={true} offset={-80}>
            Zurück nach oben
          </Link>
        </div>
      </div>
    </div>
  );
}
